import styled from "styled-components";

export const MReferralSection = styled.div`
  width: 100%;
  height: 100%;
`;
